import React from 'react';
import {
  Badge,
  Button,
  ListGroup,
  ListGroupItem,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';

import {
  listNotification,
  readNotification,
} from '../../redux/notification/notification_actions';

class Notification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShow: false,
      unreadCount: 0,
    };
  }

  componentWillMount() {
    this.props.listNotification();
  }

  componentWillReceiveProps({ isLoading, isMarkingAsRead, notifications }) {
    const loadFinished = isLoading !== this.props.isLoading && !isLoading;
    const markAsReadFinished = isMarkingAsRead !== this.props.isMarkingAsRead && !isMarkingAsRead;
    if (loadFinished || markAsReadFinished) {
      const unreadCount = notifications.reduce((sum, { read }) => read ? sum : sum + 1, 0);
      this.setState({ unreadCount: unreadCount });
    }
  }

  markNotificationAsRead() {
    const ids = this.props.notifications
      .filter(({ read }) => !read)
      .map(({ id }) => id);

    if (ids) {
      this.props.readNotification(ids);
    }
  }

  onToggleNotificationTrayHandler(event) {
    this.setState(
      {
        isShow: !this.state.isShow,
      },
      () => {
        if (this.state.isShow) {
          this.markNotificationAsRead();
        }
      },
    );
  }

  onClickNotificationHandler(extraJsonString) {
    if (!extraJsonString) {
      return;
    }

    try {
      const extra = JSON.parse(extraJsonString);
      if (this.props.onNotificationClick) {
        this.props.onNotificationClick(extra);
      }
    } catch (e) {
      console.log(e);
    }
  }

  renderNotificationList() {
    const { notifications, t } = this.props;
    return (
      <Popover
        id="notification-popover"
        title={t('notifications')}
      >
        <ListGroup>
          {notifications.map(({ id, message, read, extra }) => (
            <ListGroupItem key={`notification-${id}`} onClick={() => this.onClickNotificationHandler(extra)}>
              {read ? message : <strong>{message}</strong>}
            </ListGroupItem>
          ))}
        </ListGroup>
      </Popover>
    );
  }

  render() {
    const { unreadCount } = this.state;

    return (
      <OverlayTrigger
        trigger="click"
        placement="bottom"
        overlay={this.renderNotificationList()}
      >
        <Button
          bsStyle="link"
          style={{ color: 'unset' }}
          onClick={event => this.onToggleNotificationTrayHandler(event)}
        >
          <i className="fas fa-bell" style={{ fontSize: '1.5em' }} />
          {unreadCount > 0 && <Badge>{unreadCount}</Badge>}
        </Button>
      </OverlayTrigger>
    );
  }
}

const mapStateToProps = state => ({
  notifications: state.notification.orderedIds.map(id => state.notification.objects[id]),
  isLoading: state.notification.isLoading,
  isMarkingAsRead: state.notification.isMarkingAsRead,
});

const mapDispatchToProps = dispatch => ({
  listNotification: () => defaultRejectHandler(dispatch(listNotification())),
  readNotification: (ids) => defaultRejectHandler(dispatch(readNotification(ids))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Notification),
);



// WEBPACK FOOTER //
// ./src/components/notification/Notification.js